export interface IAffiliateStore {
    referralCode?: string;
    referralExpiry?: number;
}

export default {} as IAffiliateStore;
